import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import LoanCalculator from '../../components/LoanCalculator';

const LoanCalc: React.FC = () => (
  <ToolLayout
    title="Loan Calculator - Monthly Payment & Amortization | AllTools"
    description="Calculate monthly loan payments, total interest, and amortization schedule. Free mortgage and loan calculator."
    canonicalPath="/loan-calculator"
  >
    <LoanCalculator />
  </ToolLayout>
);

export default LoanCalc;
